import React, { useMemo } from 'react';
import clsx from 'clsx';
import { BaseAlert, BaseAlertProps } from '../Alert';
import { IconActionCheck, IconStatusError, IconStatusInfo } from '../../icons';

export enum ToastVariant {
  info = 'info',
  success = 'success',
  error = 'error',
  warning = 'warning'
}

export interface ToastProps extends BaseAlertProps {
  /**
   * Вариант тоста
   */
  variant?: ToastVariant;
  /**
   * Вызывается, когда компонент хочет закрыть тост изнутри.
   * Передается из react-toastify
   */
  closeToast?: () => void;
}

export function Toast({
  variant = ToastVariant.info,
  icon,
  className,
  closeToast,
  ...props
}: ToastProps) {
  const toastIcon = useMemo(() => {
    return icon
      ? icon
      : {
          [ToastVariant.info]: IconStatusInfo,
          [ToastVariant.success]: IconActionCheck,
          [ToastVariant.warning]: IconStatusInfo,
          [ToastVariant.error]: IconStatusError
        }[variant];
  }, [icon, variant]);

  return (
    <BaseAlert
      className={clsx(
        'hse-Toast',
        {
          [`hse-Toast_variant_${variant}`]: variant
        },
        className
      )}
      icon={toastIcon}
      close={closeToast}
      {...props}
    />
  );
}

Toast.Variant = ToastVariant;
